export default __webpack_public_path__ + "static/media/logoHorizontalItai.325e2eec.svg";